<template>
    <div class="message">
        <div class="contain">
            <el-row class="first">
                <el-col :span="24">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="平台通知" v-if="!YS" name="first">
                            <span slot="label">
                                平台通知
                                <el-badge
                                    style="margin-left: 10px;"
                                    :value="counts.pt"
                                    v-show="one"
                                />
                            </span>
                            <el-row class="others">
                                <el-col :span="24" class="notice-title">
                                    <span class="fl notice-title-t">{{ptList.noticeHead}}</span>
                                    <span class="fr notice-title-s">{{ptList.appCreatDate}}</span>
                                </el-col>
                                <el-col :span="24" class="border-solid"></el-col>
                                <el-col :span="24" class="notice-content">{{ptList.content}}</el-col>
                            </el-row>
                        </el-tab-pane>
                        <!-- <el-tab-pane label="系统消息" v-if="!YS" name="second">
                            <span slot="label">
                                系统消息
                                <el-badge style="margin-left: 10px;" :value="counts.xt" />
                            </span>
                        </el-tab-pane>-->
                        <el-tab-pane label="物流消息" v-if="!YS" name="third">
                            <span slot="label">
                                物流消息
                                <el-badge
                                    style="margin-left: 10px;"
                                    :value="counts.wl"
                                    v-show="two"
                                />
                            </span>
                            <el-row class="others" v-for="(item,index) in wlList" :key="index">
                                <el-col :span="24" class="notice-title">
                                    <span class="fl notice-title-t">{{item.title}}</span>
                                    <span class="fr notice-title-s">{{getTime(item.createDate)}}</span>
                                </el-col>
                                <el-col :span="24" class="border-solid"></el-col>
                                <el-col :span="24" class="notice-content">
                                    订单编号为({{item.spDdgl}}),
                                    {{item.message}}
                                    <span
                                        class="red-color-font shou"
                                        @click="wlDetail(item.spDdgl)"
                                    >
                                        前往查看
                                        <!-- <i class="el-icon-d-arrow-right"></i> -->
                                    </span>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="医师消息" v-if="!YS" name="fourth">
                            <span slot="label">
                                医师消息
                                <el-badge :value="counts.ys" v-show="three" />
                            </span>
                            <el-row
                                class="others"
                                v-for="(itemhz,indexhz) in hzList"
                                :key="indexhz"
                            >
                                <el-col :span="24" class="notice-title">
                                    <span class="fl notice-title-t">【{{itemhz.type}}】</span>
                                    <span class="fr notice-title-s">{{getTime(itemhz.date)}}</span>
                                </el-col>
                                <el-col :span="24" class="border-solid"></el-col>

                                <el-col :span="24" class="notice-content">
                                    来自
                                    <span v-if="itemhz.hospital">(</span>
                                    {{itemhz.hospital}}
                                    <span
                                        v-if="itemhz.hospital"
                                    >)</span>
                                    <span v-if="itemhz.title">(</span>
                                    {{itemhz.title}}
                                    <span
                                        v-if="itemhz.title"
                                    >)</span>
                                    ({{itemhz.name}})
                                    <span
                                        v-if="itemhz.type == '医师回复'"
                                    >回复了</span>
                                    <span v-else>申请查看</span>
                                    您关于
                                    ({{itemhz.disease}})病历档案,
                                    <span
                                        v-if="itemhz.type == '诊时权限'"
                                        class="red-color-font shou"
                                        @click="yonghuShouquan(itemhz.archivesId,itemhz.id)"
                                    >
                                        是否同意?
                                        <!-- <i class="el-icon-d-arrow-right"></i> -->
                                    </span>
                                    <span
                                        v-else
                                        class="red-color-font shou"
                                        @click="hzDetail(itemhz.archivesId,itemhz.medId)"
                                    >
                                        前往查看
                                        <!-- <i class="el-icon-d-arrow-right"></i> -->
                                    </span>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="患者消息" v-if="YS" name="fifth">
                            <span slot="label">
                                患者消息
                                <el-badge
                                    style="margin-left: 10px;"
                                    :value="counts.hz"
                                    v-show="four"
                                />
                            </span>
                            <el-row class="others" v-for="(item,index) in ysList" :key="index">
                                <el-col :span="24" class="notice-title">
                                    <span class="fl notice-title-t">{{item.type}}</span>
                                    <span class="fr notice-title-s">{{getTime(item.date)}}</span>
                                </el-col>
                                <el-col :span="24" class="border-solid"></el-col>
                                <el-col :span="24" class="notice-content">
                                    <span v-if="item.type=='患者回复'">
                                        ({{item.name}})向您提问有关
                                        {{item.disease}}的相关问题
                                    </span>
                                    <span v-else>
                                        ({{item.name}})
                                        <span v-if="item.status=='1'">同意</span>
                                        <span v-else>拒绝</span>
                                        了您查看
                                        {{item.disease}}的其他诊时信息
                                    </span>
                                    <!-- 诊时不是拒绝的话，就展示查看详情 -->

                                    <span
                                        v-if="item.status!='2'"
                                        class="red-color-font shou"
                                        @click="hzDetail(item.archivesId,item.medId)"
                                    >
                                        查看详情
                                        <!-- <i class="el-icon-d-arrow-right"></i> -->
                                    </span>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            title="是否同意"
            :visible.sync="dialogTableVisibleQX"
            :close-on-click-modal="false"
            class="dialogQX"
            center
        >
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="submitQX('1')" class="smallBtn red">同意</el-button>
                <el-button type="primary" @click="submitQX('2')" class="smallBtn blue">拒绝</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "message",
    data() {
        return {
            userInfo: {},
            activeName: "",
          
            hzList: [], //患者数据
            ysList: [], //医师数据
            YS: false, //不是医师登陆
            ptList: {}, //平台数据
            wlList: [], //物流数据
            dialogTableVisibleQX: false,
            archivesId: "", //档案id
            physicianDiagnoseId: "", //诊断编码
            //控制四个的消息小红点
            one: true,
            two: true,
            three: true,
            four: true
        };
    },
    methods: {
        handleClick(tab, event) {
            let that = this;
            console.log(tab.index);
            if (tab.index == 0) {
                //平台消息
                that.getPT();
                that.one = false;
                that.$store.commit("readMessage", that.counts.pt);
                 that.counts.pt = 0;
            }
            if (tab.index == 1) {
                //物流消息
                that.getWL();
                that.two = false;
                that.$store.commit("readMessage", that.counts.wl);
                  that.counts.wl = 0;
            }
            if (tab.index == 2) {
                // 患者登陆，看医师消息
                that.getHZ();
                that.three = false;
                that.$store.commit("readMessage", that.counts.ys);
                 that.counts.ys = 0;
            }
            if (tab.index == 3) {
                // 医师登陆，看患者消息
                that.getYS();
                that.four = false;
                console.log(that.counts.hz);
                that.$store.commit("readMessage", that.counts.hz);
                that.counts.hz = 0;
            }
        },
        //选页
        handleCurrentChange(v) {
            let that = this;
            that.searchObj.pageNum = v; //当前页
            that.getList();
        },

        //得到各个分类数量
        // getOwnCount() {
        //     let that = this;
        //     let url = "wlMessage/get";
        //     let params = {
        //         spCty: that.userInfo.id
        //     };
        //     that.$http
        //         .post(url, params)
        //         .then(res => {
        //             res = res.data;
        //             if (res.code == 200) {
        //                 that.counts.pt =
        //                     res.data.pt.unRead == 0 ? "" : res.data.pt.unRead;
        //                 that.counts.wl =
        //                     res.data.wl.unRead == 0 ? "" : res.data.wl.unRead;
        //                 that.counts.ys =
        //                     res.data.ys.unRead == 0 ? "" : res.data.ys.unRead;
        //                 that.counts.hz =
        //                     res.data.hz.unRead == 0 ? "" : res.data.hz.unRead;
        //                 // this.$children[0].$children[0].$forceUpdate();
        //                 let aaa = 0;
        //                 if (!that.isYS) {
        //                     aaa =
        //                         res.data.pt.unRead +
        //                         res.data.wl.unRead +
        //                         res.data.ys.unRead;
        //                 } else {
        //                     aaa = res.data.hz.unRead;
        //                 }
        //                 // that.$store.commit("computerMessageTotal", aaa);
        //             } else {
        //                 that.$message.error(res.msg);
        //             }
        //         })
        //         .catch(() => {
        //         });
        // },
        //获取消息数量
        messageCount() {
            let that = this;
            let url = "wlMessage/messageCount";
            let params = {
                spCty: that.userInfo.id,
                ys: that.YS
            };
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        // console.log("消息总条数" + res.data);
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                    
                });
        },
        getPT() {
            let that = this;
            let url = "news/getUserNotice";
            let params = new URLSearchParams();
            params.append("id", that.userInfo.id);
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.ptList = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        // 得到医师消息
        getYS() {
            let that = this;
            let url = "physician/ctyysMessageList";
            let params = new URLSearchParams();
            params.append("userId", that.userInfo.id);
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.ysList = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        //得到患者信息
        getHZ() {
            let that = this;
            let url = "physician/ctyMessageList";
            let params = new URLSearchParams();
            params.append("userId", that.userInfo.id);
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.hzList = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        getWL() {
            let that = this;
            let url = "wlMessage/getList";
            let params = {
                userId: that.userInfo.id
            };
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.wlList = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        //物流详情
        wlDetail(id) {
            this.$router.push({ path: "/logistics", query: { id: id } });
        },
        //患者消息详情，去档案医案页面
        hzDetail(id, medId) {
            localStorage.setItem("archivesId", id);
            localStorage.setItem("medId", medId);
            sessionStorage.setItem("fromMessage", "yes");
            this.$router.push({
                path: "archives"
            });
        },
        //用户是否同意医师查看其他诊时权限弹框
        yonghuShouquan(archivesId, physicianDiagnoseId) {
            this.dialogTableVisibleQX = true;
            this.archivesId = archivesId;
            this.physicianDiagnoseId = physicianDiagnoseId;
        },
        //用户是否同意医师查看其他诊时权限弹框
        submitQX(type) {
            let that = this;
            let params = {
                id: that.physicianDiagnoseId,
                archivesId: that.archivesId,
                type: type
            };
            let url = "physician/agreePhysicianWantLook";
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.dialogTableVisibleQX = false;
                        that.$message({
                            message: "您已向医师发送该消息",
                            type: "success"
                        });
                        that.getHZ();
                        that.activeName = "fourth";
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        }
    },
    created() {
        let that = this;
        //   console.log( that.counts);
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        }
        // that.getOwnCount();
        if (JSON.parse(sessionStorage.getItem("YS"))) {
            //医师身份
            // console.log("医师身份");
            that.YS = JSON.parse(sessionStorage.getItem("YS"));
            that.activeName = "fifth";
            that.getYS();
            that.four = false;
            console.log(that.counts.hz);
            that.$store.commit("readMessage", that.counts.hz);
             that.counts.hz = 0;
        } else {
            //普通用户身份
            // console.log("普通用户身份");
            that.getPT();
            that.activeName = "first";
            that.one = false;
            that.$store.commit("readMessage", that.counts.pt);
             that.counts.pt = 0;
        }
    }
};
</script>

<style scoped>
.first {
    margin-top: 50px;
    margin-bottom: 15px;
    background-color: #fff;
    padding: 15px 40px 0px;
}
.first ul li {
    display: inline-block;

    padding-bottom: 15px;
}
.first ul .el-badge {
    margin-right: 60px;
}
.border-solid {
    border: solid 1px #dddddd;
}
.others {
    background-color: #fff;
    padding: 15px 20px;
    margin-bottom: 15px;
}
.notice-title {
    margin-bottom: 15px;
}
.notice-title-t {
    font-size: 16px;
    font-weight: bold;
    line-height: 12px;
    letter-spacing: 2px;
    color: #333333;
}
.notice-title-s {
    font-size: 14px;
    line-height: 12px;
    color: #999999;
}
.notice-content {
    font-size: 14px;
    line-height: 12px;
    color: #666666;
    margin-top: 15px;
}
.active {
    border-bottom: 2px solid red;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/message.vue